/**
 * Test IDs for QA automation.
 */
export const testIds = {
  suppliersListNewSupplier: "suppliers-list-new-supplier",
} as const;
